module.exports = "/_next/static/images/PropCardCta@2x-9772bd77b597ef9b3f922d8506902fb9.webp";